import React from 'react';
import { Link } from 'react-router-dom';
import './AuthLegalNotice.css';

const AuthLegalNotice = () => {
  return (
    <p className="auth-legal-notice">
      By continuing, you agree to our{' '}
      <Link to="/terms" className="auth-legal-notice__link">
        Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link to="/privacy" className="auth-legal-notice__link">
        Privacy Policy
      </Link>
      .
    </p>
  );
};

export default AuthLegalNotice;
